export default {
  eyebrow:        "烟草·酒吧·商业转让",
  title:          "公告列表",
  refresh:        "刷新",
  export:         "导出 CSV",
  filters:        "筛选",
  results:        (n) => `${n} 条结果`,
  filtered:       "已筛选",
  page:           (p, t) => `第 ${p} / ${t} 页`,
  loading:        "加载中…",
  errorLoad:      "无法加载公告",

  filterTitle:    "筛选条件",
  reset:          "重置",
  search:         "搜索",
  searchPlaceholder: "标题、地区、城市…",
  source:         "来源",
  allSources:     "所有来源",
  sort:           "排序",
  sortDate:       "最新优先",
  sortPriceAsc:   "价格从低到高",
  sortPriceDesc:  "价格从高到低",
  price:          "价格",
  seeResults:     "查看结果",

  colTitle:       "标题",
  colPrice:       "价格",
  colLocation:    "地点",
  colSource:      "来源",
  colDate:        "日期",
  noListings:     "未找到公告",
  seeAd:          "查看公告",
  description:    "描述",
  region:         "大区",
  department:     "省份",
  address:        "地址",

  statTotal:      "总计",
  statAvgPrice:   "均价",
  statMaxPrice:   "最高价",
  ann:            "条",

  badgeNew:       "最新",
  badgeRecent:    "近期",

  navListings:    "公告列表",
  navStats:       "统计",
  navFavorites:   "我的收藏",
  navSettings:    "设置",

  emptyTitle:     "无结果",
  emptySubtitle:  "没有符合筛选条件的公告。",
  emptyReset:     "重置筛选条件",

  statWithPrice:  "有价格",
  statAnn:        "条",
  statLast7:      "本周新增",
  statLast30:     "本月新增",
  statBySrc:      "按来源",
  statSrcShare:   "来源占比",
  statPriceDist:  "价格分布",
  statByRegion:   "热门大区",
  statByDep:      "热门省份",
  statTimeline:   "近30天抓取数量",

  authLoginTitle:   "登录",
  authRegisterTitle:"创建账户",
  authFirstName:    "名",
  authLastName:     "姓",
  authGender:       "性别",
  authGenderM:      "男",
  authGenderF:      "女",
  authRequired:     "必填项",
  authEmail:        "邮箱",
  authPassword:         "密码",
  authConfirmPassword:  "确认密码",
  authPasswordMismatch: "两次密码不一致",
  authLogin:        "登录",
  authCreateAccount:"创建账户",
  authRegister:     "注册",
  authNoAccount:    "还没有账户？",
  authHasAccount:   "已有账户？",
  authLoading:      "加载中…",
  authError:        "发生错误",
  authLogout:           "退出登录",
  authContinueWithout:  "不登录继续浏览 →",
  authCheckEmail:       "请查收邮件",
  authCheckEmailSub:    "确认链接已发送至",
  authResend:           "重新发送确认邮件",
  authResending:        "发送中…",
  authResent:           "邮件已重新发送！",
  authNotVerified:      "账户未验证。",
  authVerifying:        "验证中…",
  authVerified:         "账户已激活！",
  authVerifiedSub:      "即将自动跳转。",

  favEmptyTitle:    "暂无收藏",
  favEmptySubtitle: "点击 ♡ 收藏感兴趣的公告",

  navAlerts:            "我的提醒",
  navProfile:           "我的资料",
  alertsTitle:          "我的提醒",
  alertsEmpty:          "暂无提醒",
  alertsEmptySub:       "创建提醒，当有新公告时自动收到邮件通知。",
  alertNew:             "新建提醒",
  alertName:            "提醒名称",
  alertKeywords:        "关键词",
  alertKeywordsPlaceholder: "例：烟草、酒吧…",
  alertSource:          "来源",
  alertAllSources:      "所有来源",
  alertPriceMin:        "最低价 (€)",
  alertPriceMax:        "最高价 (€)",
  alertRegion:          "大区",
  alertRegionPlaceholder: "例：Île-de-France",
  alertCreate:          "创建提醒",
  alertCreating:        "创建中…",
  alertDelete:          "删除",
  alertActive:          "已启用",
  alertInactive:        "已停用",
  alertCriteria:        "筛选条件",
  alertNoCriteria:      "所有公告",
  profileTitle:         "我的资料",
  profileInfo:          "基本信息",
  profileSave:          "保存",
  profileSaved:         "修改已保存",
  profilePassword:      "修改密码",
  profileCurrentPwd:    "当前密码",
  profileNewPwd:        "新密码",
  profileConfirmPwd:    "确认新密码",
  profilePwdUpdated:    "密码已更新",
  profileDanger:        "危险操作",
  profileDeleteAccount: "删除账户",
  profileDeleteConfirm: "请输入密码以永久删除您的账户。",
  profileDeleting:      "删除中…",
  profileSaving:        "保存中…",
  profileUpdating:      "更新中…",
};
